<script lang="ts">
    import {KpPopoverPanel, type TogglePopoverFn} from 'shared/ui-widgets/popover';
    import type {ButtonStyle, ComponentSize} from '../types';
    import type {Placement} from '@floating-ui/core';
    import {exists, uuid as generateUuid} from 'shared/utils/custom-utils';
    import {createFloatingActions} from 'svelte-floating-ui';
    import {floatingUiCommonSettings} from 'shared/utils/floating-ui-common-settings';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';

    export let id: string = generateUuid();
    export let buttonStyle: ButtonStyle = 'default';
    export let buttonSize: ComponentSize = 'md';
    export let placement: Placement = 'bottom';
    export let isLoading = false;
    export let additionalPopoverButtonClasses = '';
    export let additionalPopoverPanelClasses = '';

    $: buttonId = `${id}-popover-button`;
    $: panelId = `${id}-popover-panel`;

    let togglePopoverInner: TogglePopoverFn;

    export function togglePopover(newOpenState?: boolean) {
        togglePopoverInner(newOpenState);
    }

    let popoverOpen = false;

    const [floatingRef, floatingContent] = createFloatingActions(floatingUiCommonSettings(placement));
</script>

{#if !exists($$slots['whole-button'])}
    <KpButton id={buttonId}
              {buttonSize}
              {buttonStyle}
              {isLoading}
              additionalClasses={additionalPopoverButtonClasses}
              use={[floatingRef]}
              popovertarget={panelId}>

        <slot name="button" {popoverOpen}/>
    </KpButton>
{:else}
    <slot name="whole-button" {buttonId} {panelId} {floatingRef} {popoverOpen}/>
{/if}

{#if exists($$slots['popover-title'])}
    <KpPopoverPanel id={panelId}
                    use={[floatingContent]}
                    additionalClasses={additionalPopoverPanelClasses}
                    on:popover-open
                    on:popover-close
                    bind:open={popoverOpen}
                    bind:togglePopover={togglePopoverInner}
                    let:togglePopover={togglePopoverProp}
                    let:open>

        <slot name="popover-title" slot="popover-title"/>
        <slot name="popover-content" {open} togglePopover={togglePopoverProp}/>
    </KpPopoverPanel>
{:else}
    <KpPopoverPanel id={panelId}
                    use={[floatingContent]}
                    additionalClasses={additionalPopoverPanelClasses}
                    on:popover-open
                    on:popover-close
                    bind:open={popoverOpen}
                    bind:togglePopover={togglePopoverInner}
                    let:togglePopover={togglePopoverProp}
                    let:open>

        <slot name="popover-content" {open} togglePopover={togglePopoverProp}/>
    </KpPopoverPanel>
{/if}
